import api from "@/api";

export default {
  namespaced: true,
  actions: {
    paginate(_, pagination) {
      return api
        .$get("/book-categories/paginate", pagination, { noPrefix: true })
        .then(res => res.data);
    },
    create(_, channel) {
      return api.post("/book-categories", channel).then(res => res.data);
    },
    update(_, channel) {
      return api
        .put(`/book-categories/${channel.id}`, channel)
        .then(res => res.data);
    },
    delete(_, channel_id) {
      return api.delete(`/book-categories/${channel_id}`).then(res => res.data);
    }
  }
};
